<template>
  <div class="loading" v-if="finding">
    <loading />
  </div>
  <div class="stretchBox" v-else-if="response !== ''">
    <div class="detailBox rounded shadow" v-if="response === 'found'">
      <h3>Company Found:</h3>
      <h2>{{ companyData.company_name }}</h2>
      <p>If this is the correct company, please continue</p>
      <span>
        <p>
          otherwise please
          <a @click="tryAgain">try again</a>
        </p>
      </span>
    </div>
    <div class="detailBox rounded shadow" v-else-if="response === '404'">
      <h2>Company not found</h2>
      <span>
        <p>
          please confirm the reg number is correct and try again
          <a @click="tryAgain">try again</a>
        </p>
      </span>
    </div>
    <div class="stretchBox" v-else>
      <h2>an unknown error has occurred</h2>
      <span>
        <p>
          please
          <a @click="tryAgain">try again</a>
        </p>
      </span>
    </div>
  </div>
  <div class="searchBar rounded" v-else>
    <input
      v-model.trim="companyReg"
      placeholder="Company reg number"
      @keydown.enter="findCompany"
    />
    <div class="searchButton Enabled" @click="findCompany">
      <h3>Find</h3>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.stretchBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading {
  width: 30vw;
  @media screen and (orientation: portrait) {
    width: 100vw;
  }
}
.searchBar {
  background-color: var(--base-colour, #535450);
  display: grid;
  grid-template-columns: auto auto;
}
.searchButton {
  // border-radius: 0 0 1.5em 1.5em;
  background-color: var(--base-colour, #535450);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.5em;
  padding-right: 1em;
  &:hover {
    background-color: var(--hover-colour, #bbbbbb);
  }
}
</style>
<script>
import loading from "@/components/loading";
export default {
  props: {
    nextRoute: {
      type: String,
      default: "2",
    },
  },
  components: {
    loading,
  },
  methods: {
    cancel: function () {
      if (this.lastRoute) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    next: function () {
      this.$store.dispatch("setFormData", {
        businessName: this.companyName,
        companyReg: this.companyReg,
      });
      this.$router.push(this.nextRoute);
    },
    tryAgain: function () {
      this.finding = false;
      this.response = "";
    },
    findCompany: function () {
      this.finding = true;
      this.response = "";
      if (process.env.VUE_APP_MODE !== "production") {
        this.$gtag.event("stagingCompanyReg");
      } else {
        this.$gtag.event("companyReg");
      }
      this.axios
        .post("/api/companysearch", {
          reg: this.companyReg,
        })
        .then((data) => {
          if (data.data !== "") {
            this.$store.dispatch("setCompanyData", data.data);
            this.$store.dispatch("setFormData", {
              businessName: data.data.company_name,
              postCode: "",
            });
            this.$emit('setName', data.data.company_name)
            this.companyName = data.data.company_name;
            this.response = "found";
            this.finding = false;
            return;
          }
          this.response = "404";
          this.finding = false;
        })
        .catch((err) => {
          this.response = "error";
          this.finding = false;
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.lastRoute = from;
    });
  },
  beforeMount: function () {
    if (this.$store.state.formData.businessName.length > 0) {
      this.companyName = this.$store.state.formData.businessName;
      this.companyReg = this.$store.state.formData.companyReg;
      this.response = "found";
    }
  },
  data: function () {
    return {
      companyName: "",
      companyReg: "",
      findingData: false,
      findingEnabled: true,
      response: "",
      lastRoute: null,
    };
  },
  computed: {
    finding: {
      get: function () {
        return !this.findingEnabled || this.findingData;
      },
      set: function (newVal) {
        this.findingData = newVal;
        this.$emit("found", this.response === "found" && !this.finding);
        if (newVal) {
          this.findingEnabled = false;
          setTimeout(() => {
            this.findingEnabled = true;
            this.$emit("found", this.response === "found" && !this.finding);
          }, 1500);
        }
      },
    },
    companyData: function () {
      return this.$store.state.companyData;
    },
    buttonEnabled: function () {
      let r = this.response === "found" && !this.finding;
      return r;
    },
  },
};
</script>